// Lo que se le dice a quien guarda una línea (card Fnvibexi, /ux 04/11). Si el cambio mueve los números
// (presupuesto, objetivos, días que trabaja), el backend publica el recálculo y responde `recalculating: true`:
// hasta que termina, el Tablero y las alertas muestran los números de antes, y a Atómica le pareció que su cambio
// no se había tomado. Ahí se dice dónde se va a ver; si no recalcula (un cambio de nombre), el aviso de siempre.
export function lineSavedMessage(response, t, savedText) {
    const recalculating = !!(response && response.data && response.data.recalculating);
    return recalculating ? t('line_recalculation.saved_recalculating') : savedText;
}
